import styled from 'styled-components';
import { color } from 'styles/pallete';
import { svg } from 'utils/imgList';

export const container = styled.div`
	width: 100%;
	height: 100vh;
	background-color: ${color.interface.lightGray4};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	background-image: url(${svg.loginBackground});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	img {
		width: 150px;
	}
`;

export const notice = styled.div`
	width: fit-content;
	padding: 4rem 2rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	background-color: ${color.interface.white};
	border-radius: 5px;

	> p {
		width: 30vw;
		font-size: 1.3rem;
		text-align: center;
		color: ${color.interface.lightGray};
	}

	> a {
		all: unset;
	}

	@media (max-width: 1000px) {
		> p {
			width: 60vw;
		}
	}
`;

export const btnHome = styled.label`
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 5px;
	background-color: #00427c;
	padding: 1rem;
	color: ${color.interface.white};
`;
